"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_USER_ITEMS = void 0;
var MAX_USER_ITEMS = exports.MAX_USER_ITEMS = 10;